export const offer = {
  header_title: "Offers",
  update_form_name: " Update Offer",
  create_form: {
    title: "Create offer",
    name: "Name",
    name_placeholder: "Offer name",
    price: "Price",
    price_placeholder: "Offer price",
    type: "Service type",
    type_placeholder: "Service type",
    description: "Description",
    description_placeholder: "Offer description",
    class: "Accounting class",
    class_placeholder: "Accounting class",
    category: "Category",
    category_placeholder: "Offer category",
    submit: "Create",
    creating: "Creating...",
    category_custom: "Other (enter manually)",
    updating: "Updating...",
    update: "Update",
    types: {
      product: "Product",
      service: "Service",
    },
    categories: {
      informatique: "IT",
      nourriture: "Food",
      electronique: "Electronics",
      mobilier: "Furniture",
      transport: "Transport",
      services: "Services",
      marketing: "Marketing",
      sante: "Health",
      construction: "Construction",
      education: "Education",
    },

    create_success: "Offer created successfully",
    update_success: "Offer updated successfully",
    delete_success: "Offer deleted successfully",
    create_error: "Error creating offer",
    update_error: "Error updating offer",
    delete_error: "Error deleting offer",
    class_custom: "Other (enter manually)",
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
  },
  delete_dialog: {
    title: "Delete offer",
    description:
      "Are you sure you want to delete this offer? This action cannot be undone.",
    confirm: "Delete",
    cancel: "Cancel",
  },
  back_to_list: "Back to list",
};
